import { Button, Icon } from "@components";
import { FC } from "react";
interface Props {
    message: string;
    onRetry?: () => void
}

export const ChatErrorMessage: FC<Props> = ({ message, onRetry }) => (
    <div
        className="flex items-center justify-between 
             bg-error/10 text-error px-4 py-2 rounded-md"
    >
        <span className="text-sm">{message}</span>

        {
            onRetry && (
                <Button onClick={onRetry} className="btn btn-ghost btn-sm">
                    <Icon iconName="RefreshCw" size={16} />
                </Button>
            )
        }
    </div>
)